export class AuditLogEntryDto implements IAuditLogEntryDto{
    Description: string;
    User: string;
    TimeStamp: Date;
    LogType: number;
    EventType: number;
    TrustWorthy: boolean;
    ServerGuid: string;
    TenantGuid: string;
}

export class NetworkChangeEntryDto extends AuditLogEntryDto {
    Details: NetworkChangeDetails;
}

export interface IAuditLogEntryDto {

}

export class NetworkChangeDetails {
    DeviceName: string;
    DeviceIPAddress: string;
    DeviceMacAddress: string;
    IfIndex: number;
    IfName: string;
}